import React from 'react';

const Header2 = () => {
    return (
        <div style={{ position: 'sticky', top: 0, backgroundColor: '#333', zIndex: 1000, padding: '20px' }}>
            <div className="header-content container" style={{ display: 'flex', justifyContent: 'flex-start' }}>
                <img
                    src="img/resources/alt_logo_300.png"
                    alt="Header Image"
                    style={{
                        maxWidth: '200px',
                        height: 'auto',
                        alignSelf: 'center'
                    }}
                    className="header-image"
                />
            </div>
            <style jsx>{`
                @media (max-width: 600px) {
                    .header-content {
                        justify-content: center;
                    }
                    .header-image {
                        max-width: 150px;
                    }
                }
            `}</style>
        </div>
    );
};

export default Header2;